import { render } from "./SendAllowanceWidget.vue?vue&type=template&id=06044318&scoped=true"
import script from "./SendAllowanceWidget.vue?vue&type=script&lang=js"
export * from "./SendAllowanceWidget.vue?vue&type=script&lang=js"

import "./SendAllowanceWidget.vue?vue&type=style&index=0&id=06044318&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06044318"]])

export default __exports__